module.exports = __webpack_public_path__ + "static/media/rotate-right.de268df9.svg";